import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import ConfigContext from '../../utils/ConfigContext/ConfigContext';
import { assembleFloorPlanHeaderTextData } from '../../utils/DrupalEntityTypes/FloorPlan/FloorPlanHelpers';

import DetailHeader from '../Detail/DetailHeader';
import CommunityContact from '../Community/CommunityContact';

import './FloorPlanPrintIndividualPage.scss';

const FloorPlanPrintIndividualPage = ( props ) => {
  const { children, floorPlanData } = props;

  const [ detailHeaderText, setDetailHeaderText ] = useState( null );
  const [ communityData, setCommunityData ] = useState( {} );

  const { config } = useContext( ConfigContext );
  const {
    communityLogo,
    communityName,
  } = config;

  // Assemble header textdata if needed.
  useEffect( () => {
    const headerTextData = assembleFloorPlanHeaderTextData( floorPlanData );
    setDetailHeaderText( headerTextData );
  }, [ floorPlanData ] );

  // Get community contact data from floor plan.
  const fpCommunityData = floorPlanData?.community;
  useEffect( () => {
    if(fpCommunityData) {
      setCommunityData(fpCommunityData);
    }
  },[ fpCommunityData ] )

  return detailHeaderText && communityLogo && (
    <div className="floorPlanPrintPage__individualPage">

      <div className="floorPlanPrintPage__header">
        <div className="floorPlanPrintPage__branding">
          <img
            className="floorPlanPrintPage__logo"
            src={communityLogo}
            alt={communityName}
          />
        </div>
      </div>

      <DetailHeader
        text={ detailHeaderText }
      />

      { children }

      <div className="floorPlanPrintPage__footer">
        <div className="floorPlanPrintPage__contactWrapper">
          <CommunityContact
            className="floorPlanPrintPage__contact"
            communityData={{
              email: communityData?.email,
              phone: communityData?.phone,
            }}
          />
        </div>
      </div>

    </div>
  )
};

export default FloorPlanPrintIndividualPage;